<template>
  <content-loader :height="300" preserveAspectRatio="none">
    <rect x="0" y="20" rx="4" ry="4" width="200" height="180" />
    <rect x="210" y="40" rx="4" ry="4" width="150" height="20" />
    <rect x="210" y="80" rx="4" ry="4" width="180" height="10" />
    <rect x="210" y="100" rx="4" ry="4" width="180" height="10" />
    <rect x="210" y="120" rx="4" ry="4" width="180" height="10" />
    <rect x="10" y="230" rx="4" ry="4" width="190" height="40" />
    <rect x="210" y="230" rx="4" ry="4" width="180" height="40" />
  </content-loader>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: "news-loading-skeleton",
  components: { ContentLoader }
}
</script>

<style scoped>
</style>